export const initialState = [
    {
        id: 1,
        title: "Boost your conversion rate",
        blogImage: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
        author: {
            id: 1,
            name: "Scott Graham",
            image: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
        },
        category: "Node",
        totalReadTime: 11,
        dateTime: new Date().toDateString()
    },
    {
        id: 2,
        title: "Check your conversion rate",
        blogImage: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        author: {
            id: 2,
            name: "Andrew Neel",
            image: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
        },
        category: "React",
        totalReadTime: 13,
        dateTime: new Date().toDateString()
    },
    {
        id: 3,
        title: "Desktop after work",
        blogImage: "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80",
        author: {
            id: 2,
            name: "Andrew Neel",
            image: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
        },
        category: "JavaScript",
        totalReadTime: 9,
        dateTime: new Date().toDateString()
    },
    {
        id: 4,
        title: "Brainstorming over paper",
        blogImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        author: {
            id: 1,
            name: "Scott Graham",
            image: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
        },
        category: "JavaScript",
        totalReadTime: 9,
        dateTime: new Date().toDateString()
    },
    {
        id: 5,
        title: "CSS code on a screen",
        blogImage: "https://images.unsplash.com/photo-1454165205744-3b78555e5572?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        author: {
            id: 3,
            name: "Kiran Anagani",
            image: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
        },
        category: "Node",
        totalReadTime: 9,
        dateTime: new Date().toDateString()
    },
    {
        id: 6,
        title: "Statistics on a laptop",
        blogImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=815&q=80",
        author: {
            id: 4,
            name: "Carlos Muza",
            image: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
        },
        category: "React",
        totalReadTime: 9,
        dateTime: new Date().toDateString()
    }
];